<script>
    import SubPageHeader from '../components/SubPageHeader.svelte'
    import { translations, current_lang, artists_api_storage} from '../stores.js';
    import { afterUpdate } from 'svelte';
    import WaitingPlaceholderBox from '../components/WaitingPlaceholderBox.svelte'

    export let params = {id}

    let artist = null;
    let artists = null;
    let description = "";
    let image = "";

    function find_artist(artist_id) {
        artists = $artists_api_storage;

        if(artists != null){
            artist = artists.find(x => x.id === parseInt(artist_id));
            if(artist != null){
                if($current_lang == "FI"){ 
                    description = artist.texts.fi;
                }
                if($current_lang == "EN"){
                    description = artist.texts.en;
                }

                if(artist.mobilePictureUrl){
                    image = artist.mobilePictureUrl;
                }else if(artist.fullPictureUrl){
                    image = artist.fullPictureUrl;
                }
            }
        }
    }
    let image_load = null;
    afterUpdate(() => {
        find_artist(params.id);

        image_load = image_get();
	});


	async function image_get() {
        
        if(image == ""){
            return;
        }

		const img = new Image();
        img.src = image;

        const res = await img.decode()
        .then(() => {
            return img.src;
        })
        .catch((encodingError) => {
            // Do something with the error.
        })

        return res;
    }
    </script>

    <SubPageHeader page_title={$translations["PROGRAM"][$current_lang]} />
    {#if artists != null}
        {#if artist != null}
            <div class="content-container full">
                {#if image != ""}
                    {#await image_load}
                        <WaitingPlaceholderBox height={180} margin_bottom={0} />
                    {:then img_src}
                        {#if img_src != null && img_src != ""}
                            <div class="image-container" style="background-image: url({img_src});"></div>
                        {/if}
                    {:catch error}
                        <p>{error}</p>
                    {/await}
                {/if}
                <div class="inner-padding-container">
                    <h2>{@html artist.title}</h2>
                    {@html description}
                </div>
            </div>
        {/if}
    {/if}
    
    <style>
    h2{
        font-size: 1.6rem;
    }

    .image-container{
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        aspect-ratio: 1 / 1;
        width: auto;
    }
    </style>